<template>
  <div class="broker-info-container">
    <v-card v-if="profileStatus==='client'">
      <v-card-title class="card-title">
        Agent
        <!-- <span @click="showModal=true">UPDATE BROKER INFO</span> -->
      </v-card-title>
      <v-divider />
      <v-card-text v-if="profile" class="agent-broker-info">
        <v-flex>
          <!-- <span>Agent</span> -->
          <span>{{ profile.name }}</span>
          <span>{{ profile.email }}</span>
          <span>{{ profile.phone }}</span>
        </v-flex>
        <!-- <v-divider /> -->
        <!-- <v-flex>
          <span>Broker</span>
          <span>{{ profile.name }}</span>
          <span>{{ profile.email }}</span>
          <span>{{ profile.phone }}</span>
        </v-flex> -->
      </v-card-text>
    </v-card>
    <!-- <default-modal
      :show-modal="showModal"
      :max-width="'504px'"
      :width="'100%'"
      @close-modal="showModal=false"
    >
      <v-card-title class="modal-title">
        Update Broker Information
      </v-card-title>
      <v-flex class="agent-data-container">
        <span>NAME</span>
        <input v-model="profileForm.name" type="text" :placeholder="profileForm.name">
        <span>EMAIL</span>
        <input type="text" :placeholder="profile.email" disabled>
        <span>PHONE</span>
        <input v-model="profileForm.phone" type="text" :placeholder="profileForm.phone">
      </v-flex>
      <v-btn
        :color="colors.hwayzBrandBlue"
        class="save-changes-button"
        @click="updateInfo"
      >
        Save Changes
      </v-btn>
      <v-btn
        :color="colors.hwayzWhite"
        class="cancel-button"
        @click="showModal=false"
      >
        Cancel
      </v-btn>
    </default-modal> -->
  </div>
</template>
<script>
// import DefaultModal from '../../components/modals/DefaultModal'
import { updateMyProfile } from '../../services/profile'
import { mapState, mapMutations } from 'vuex'
import colors from '../../scss/_colors.scss'
export default {
  components: {
    // DefaultModal
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showModal: false,
      profileForm: {
        name: '',
        phone: ''
      },
      colors
    }
  },
  computed: {
    ...mapState('common', ['profileStatus'])
  },
  watch: {
    profile() {
      this.getAgentData()
    }
  },
  created() {
    this.getAgentData()
  },
  methods: {
    ...mapMutations('agent', {
      setAgentData: 'SET_AGENT_DATA'
    }),
    async updateInfo() {
      this.showModal = false
      const updatedBrokerInfo = await updateMyProfile(this.profileForm)
      this.setAgentData(updatedBrokerInfo.data)
    },
    getAgentData() {
      for (let key in this.profileForm) {
        if (this.profile && this.profile[key]) {
          this.profileForm[key] = this.profile[key]
        }
      }
    }
  }
}

</script>
<style lang="sass">
.agent-data-container
  display: flex
  justify-content: flex-start
  flex-direction: column
  input[type=text]
    border: 1px solid grey
    height: 40px
    margin: 1rem 0 2rem
    padding-left: 15px
.agent-data-container input
  display: block !important
  text-align: left !important
.inputs
  display: flex
  flex-direction: column
.inputs span, .agent-data-container span
  display: block !important
  text-align: left !important
  font-weight: 450 !important
.data-container
  display: flex
  justify-content: space-between
  flex-direction: row
  input[type=text]
    border: 1px solid grey
    height: 40px
    width:  100%
    margin: 1rem 0 2rem
    padding-left: 15px
.save-changes-button, .cancel-button
  width: 100% !important
  margin: 0.5rem auto !important
  font-weight: 500 !important
  border-radius: 4px !important
.save-changes-button
  color: $hwayzWhite !important
.cancel-button
  border: 0.6px solid black !important
.agent-broker-info
  display: flex
  justify-content: flex-start
  flex-direction: column
  text-align: left
  padding: 0px 16px !important
.agent-broker-info .flex
  padding: 0.7rem 0
.agent-broker-info span
  display: block
  padding: 0.3rem 0
.agent-broker-info span:first-child
  font-weight: 500 !important
  padding-bottom: 0.5rem
.broker-info-container
  display: flex
  flex-grow: 1
  align-items: stretch
  height: 100%
  max-height: 500px
.broker-info-container .v-card
  height: 100%
  width: 100%
</style>
